import { FC } from 'react';
import { GoalReviewItem } from '@new/common/ui/GoalReviewItem/GoalReviewItem';
import { GeneralNotes } from '@new/common/ui/GeneralNotes/GeneralNotes';
import { type SubmissionDetailData } from './submissionDetail.mappers';

interface SubmissionDetailContentProps {
  data: SubmissionDetailData;
}

export const SubmissionDetailContent: FC<SubmissionDetailContentProps> = ({ data }) => (
  <div className="flex flex-col gap-4">
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-col lg:flex-row items-start lg:items-center gap-3">
        {data.statusBadge}
        {data.instructorName && (
          <p className="[font-size:var(--fs-p5)]! text-(--neutral-black-NB700)! m-0!">
            Reviewed by <span className="font-semibold">{data.instructorName}</span>
          </p>
        )}
      </div>
      {data.date && (
        <p className="[font-size:var(--fs-p5)]! text-(--neutral-black-NB500)! m-0!">{data.date}</p>
      )}
    </div>

    {data.rejectionReason && (
      <div className="rounded-xl! border border-(--danger-D300) bg-(--danger-D100) p-4">
        <p className="[font-size:var(--fs-l5)]! font-semibold text-(--danger-D700)! m-0! mb-2">
          Cancellation Reason
        </p>
        {data.cancelledByName && (
          <p className="[font-size:var(--fs-p5)]! text-(--danger-D700)! m-0! mb-1">
            Cancelled by <span className="font-semibold">{data.cancelledByName}</span>
          </p>
        )}
        <p className="[font-size:var(--fs-p5)]! text-(--danger-D700)! m-0!">
          {data.rejectionReason}
        </p>
      </div>
    )}

    {data.goals.length > 0 && (
      <div className="flex flex-col gap-2">
        {data.goals.map(({ goal, rating, note }) => (
          <GoalReviewItem key={goal.id} goal={goal} rating={rating} note={note} readonly />
        ))}
      </div>
    )}

    <GeneralNotes value={data.generalNote} readonly />
  </div>
);
